import { PromptParts } from './types';

export const ASPECT_RATIO_OPTIONS = [
  { value: '1:1', label: '1:1 — Square (Suno native)' },
  { value: '5:7', label: '5:7 — Album Cover (legacy)' },
  { value: '3:2', label: '3:2 — Landscape' },
  { value: '16:9', label: '16:9 — Widescreen' },
  { value: '4:5', label: '4:5 — Portrait' },
  { value: '3:4', label: '3:4 — Tall Portrait' },
  { value: '2:3', label: '2:3 — Tall Vertical' },
  { value: '3:1', label: '3:1 — Ultra-wide Banner' },
];

export const TEXT_MEDIUM_OPTIONS = [
  { value: '', label: 'Auto (AI decides)' },
  { value: 'embossed metallic letterpress', label: 'Embossed Letterpress' },
  { value: 'neon sign glow with light bleed', label: 'Neon Sign' },
  { value: 'hand-lettered chalk on dark surface', label: 'Chalk Lettering' },
  { value: 'spray-painted stencil street art', label: 'Spray Paint / Stencil' },
  { value: 'vintage marquee light-up letters', label: 'Marquee Lights' },
  { value: 'etched stone serif engraving', label: 'Stone Engraving' },
  { value: 'gold foil stamped on dark matte', label: 'Gold Foil Stamp' },
  { value: 'glitch distortion digital type', label: 'Glitch / Digital' },
  { value: 'tattoo-style blackletter ink', label: 'Tattoo Blackletter' },
  { value: 'retro chrome 3D extruded type', label: 'Retro Chrome 3D' },
  { value: 'burned woodgrain pyrography', label: 'Woodburn / Pyrography' },
  { value: 'dripping liquid paint typography', label: 'Dripping Paint' },
];

export const FRAMEWORK_CATEGORIES = [
  {
    id: 'subject',
    title: 'Subject Definition',
    description: 'The anchor of the image. What is it primarily about?',
    placeholder: 'e.g., A weathered cybernetic samurai with glowing blue eyes',
    iconName: 'User'
  },
  {
    id: 'action',
    title: 'Action & Context',
    description: 'What the subject is doing and why it matters.',
    placeholder: 'e.g., Kneeling in prayer at a digital shrine',
    iconName: 'Zap'
  },
  {
    id: 'environment',
    title: 'Environment & Setting',
    description: 'Where the scene takes place. Ground it.',
    placeholder: 'e.g., A rainy neon-lit alley in Tokyo, 2099',
    iconName: 'MapPin'
  },
  {
    id: 'mood',
    title: 'Mood & Story',
    description: 'The emotional tone and implied narrative.',
    placeholder: 'e.g., Melancholic and serene, a quiet moment before battle',
    iconName: 'Moon'
  },
  {
    id: 'style',
    title: 'Visual Style',
    description: 'Genre, era, medium, and inspirations. Be concrete — "shot on Hasselblad, 90mm" beats "professional photo."',
    placeholder: 'e.g., Editorial photography, Blade Runner 2049 aesthetic, shot on Hasselblad, 90mm, f/2.8',
    iconName: 'Palette'
  },
  {
    id: 'lighting',
    title: 'Lighting & Color',
    description: 'Lighting setup and color grading. Separate from mood.',
    placeholder: 'e.g., Rembrandt key light from upper-left, soft fill from right, warm tones',
    iconName: 'Sun'
  },
  {
    id: 'camera',
    title: 'Camera & Composition',
    description: 'Lens choice, angle, framing, and depth of field.',
    placeholder: 'e.g., 85mm lens, f/1.8, low angle, shallow depth of field',
    iconName: 'Camera'
  },
  {
    id: 'detail',
    title: 'Detail & Texture',
    description: 'Materials, micro details, and surface realism.',
    placeholder: 'e.g., Scratched metal, wet pavement reflections, micro-LED sparks',
    iconName: 'Layers'
  },
  {
    id: 'quality',
    title: 'Quality & Realism',
    description: 'Fidelity, sharpness, and rendering quality.',
    placeholder: 'e.g., 8k resolution, photorealistic, sharp focus, raw photo',
    iconName: 'CheckCircle'
  },
  {
    id: 'negatives',
    title: 'Negative Constraints',
    description: 'What to prevent. Use "NO X" format for ChatGPT Images 2.0.',
    placeholder: 'e.g., NO extra limbs, NO distortion, NO blur, NO watermark',
    iconName: 'XCircle'
  }
];

export const INITIAL_PROMPT_STATE: PromptParts = {
  subject: '',
  action: '',
  environment: '',
  mood: '',
  style: '',
  lighting: '',
  camera: '',
  detail: '',
  quality: '',
  negatives: 'NO watermark, NO extra limbs, NO distortion, NO blur, NO compression artifacts',
  songTitle: '',
  artistName: '',
  aspectRatio: '1:1',
  textMedium: ''
};
